import { useTabsContext } from './useTabsContext';

/**
 * Individual panel component.
 */
export const TabPanel = (props) => {
  const { activeTab } = useTabsContext();
  return activeTab === props.index ? props.children : null;
};

TabPanel.displayName = 'TabPanel';
